import { useMutation, useQueryClient } from '@tanstack/react-query';
import { estimatePricingApplyService } from '../services/estimatePricingApply.service';
import { toast } from 'sonner';
import { useAuth } from '@/core/auth/AuthContext';

export function useApplyRatesToEstimate() {
  const queryClient = useQueryClient();
  const { profile } = useAuth();

  return useMutation({
    mutationFn: (estimateId: string) => estimatePricingApplyService.applyRatesToEstimate(profile?.id || '', estimateId),
    onSuccess: (_, estimateId) => {
      queryClient.invalidateQueries({ queryKey: ['estimates', 'resources', estimateId] });
      queryClient.invalidateQueries({ queryKey: ['estimates', 'detail', estimateId] });
      queryClient.invalidateQueries({ queryKey: ['estimates', 'items', estimateId] });
      toast.success('Đã áp đơn giá mới nhất và cuộn chi phí thành công');
    },
    onError: (error) => {
      console.error(error);
      toast.error('Lỗi khi áp đơn giá');
    },
  });
}

export function useOverrideResourcePrice() {
  const queryClient = useQueryClient();
  const { profile } = useAuth();

  return useMutation({
    mutationFn: ({ resourceId, estimateId, newPrice, reason }: { resourceId: string, estimateId: string, newPrice: number, reason: string }) => 
      estimatePricingApplyService.overrideResourcePrice(profile?.id || '', resourceId, estimateId, newPrice, reason),
    onSuccess: (_, { estimateId }) => {
      queryClient.invalidateQueries({ queryKey: ['estimates', 'resources', estimateId] });
      queryClient.invalidateQueries({ queryKey: ['estimates', 'detail', estimateId] });
      queryClient.invalidateQueries({ queryKey: ['estimates', 'items', estimateId] });
      toast.success('Ghi đè đơn giá thành công');
    },
    onError: (error) => {
      console.error(error);
      toast.error('Lỗi khi ghi đè đơn giá');
    },
  });
}
